import React from 'react';
import logo from '../../../Assets/image.png';
import styles from './Login.module.css';

const LoginCard = ({ children }) => {
    return (
        <div className={styles.loginCard}>
            <div className={styles.cardHeader}>
                <img src={logo} alt="SclinEDC Logo" className={styles.logoImage} />
                <h3 className={styles.cardTitle}>Sign in</h3>
                {/* <p className={styles.cardSubtitle}>
                    Don't have an account? <a href="/signup" className={styles.signupLink}>Sign up</a>
                </p> */}
            </div>
            {children}
        </div>
    );
};

export default LoginCard;